import { ColorType, LineStyle, createChart } from "lightweight-charts";
import { IRunningTotal } from "motw_core/DTOs/IRunningTotal";
import * as React from "react";
import ChevronPanel from "source/app/presentation/Shared/ChevronPanel/ChevronPanel";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";
import MotwLogicServer from "source/app/services/External/LogicServer/MotwLogicServer";
import { LoadingSpinner } from "source/app/presentation/MainPanel/Calendar/LoadingSpinner";
import { IBOMProgressChartState } from "source/app/presentation/MainPanel/Workflows/BookOfMind/Display/ProgressChart/IBOMProgressChartState";

export function BOMProgressChart() {
    const [state, setState] = React.useState<IBOMProgressChartState>({
        isOpen: false,
        data: undefined,
    });

    React.useEffect(() => {
        if (!state.isOpen) {
            return;
        }

        if (state.data === undefined) {
            let isCurrent = true;

            MotwLogicServer.GetBookOfMindProgressData().then((data) => {
                if (isCurrent) {
                    setState((currentState) => ({ ...currentState, data }));
                }
            });

            return () => {
                isCurrent = false;
            };
        }
    }, [state.isOpen]);

    React.useEffect(() => DrawChart(state), [state]);

    return (
        <div>
            <ChevronPanel
                id="LWC_ChevronPanel"
                label="progress graph"
                whenClicked={() =>
                    setState({ ...state, isOpen: !state.isOpen })
                }
                dynamicOpacity={false}
                withClasses={StyleClassAuto({
                    textAlign: `center`,
                    margin: `5px`,
                })}
            >
                <BOMProgress {...{ data: state.data }} />
            </ChevronPanel>
        </div>
    );
}

function BOMProgress({ data }: { data: IRunningTotal[] | undefined }) {
    if (!data || data.length === 0) {
        return (
            <div style={{ margin: `5px` }}>
                <div
                    className={StyleClassAuto({
                        width: `100%`,
                        textAlign: `center`,
                    })}
                >
                    <LoadingSpinner />
                </div>
            </div>
        );
    }

    return (
        <div
            id="lwc_container"
            className={StyleClassAuto({
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                margin: "5px",
                width: `100%`,
                height: `300px`,
            })}
        ></div>
    );
}

function DrawChart(state: IBOMProgressChartState) {
    if (!state.data || state.data.length === 0 || !state.isOpen) {
        return;
    }

    const chart = createChart("lwc_container", {
        layout: {
            background: {
                type: ColorType.VerticalGradient,
                topColor: `#8f8361`,
                bottomColor: `#3e444d`,
            },
            textColor: `white`,
        },
        grid: {
            vertLines: { color: "#4B4B4B", style: LineStyle.SparseDotted },
            horzLines: { color: "#4B4B4B", style: LineStyle.SparseDotted },
        },
    });

    const lineSeries = chart.addLineSeries({
        color: `#82ed3b`,
    });

    const mappedData = state.data.map((runningTotalRecord) => {
        return {
            time: runningTotalRecord.date,
            value: runningTotalRecord.runningTotal,
        };
    });

    lineSeries.applyOptions({
        priceFormat: {
            type: "price",
            precision: 0,
            minMove: 1,
        },
    });

    lineSeries.setData(mappedData);

    return () => chart.remove();
}
